import React, { useEffect } from "react";
import CloudNavbar from "./../components/CloudNavbar/CloudNavbar";
import Routes from "./Routes";
import config from "config";
import { useMsal } from "Auth/msal-context";
import { useDispatch } from "react-redux";
import { fetchCustomers } from "./../ducks/customersDuck";
import { Box } from "@mui/material";

const AppContainer = () => {
  const { user, customerId } = useMsal();
  const dispatch = useDispatch();

  useEffect(() => {
    if (config && Object.keys(config).length > 0) {
      const data = {
        site: customerId,
      };
      if (user) {
        dispatch(fetchCustomers(data));
      }
    }
  }, [config, user]);

  return (
    <Box sx={{ margin: 0, padding: 0, height: '100dvh', width: "100vw", display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
      <CloudNavbar />
      <Box sx={{ height: "100%", width: "100%", display: 'flex', overflow: 'hidden' }}>
        <Routes />
      </Box>
    </Box>
  );
};

export default AppContainer;
